import App from "./App.vue";
import router from "./router/index.js";
import { pinia } from "./modules/pinia.js";
import vuetify from "./plugins/vuetify.js";
import { AuthenticationManagement } from "@haskoning/vue-authentication-middleware";
import {
  AuthorizationManagement,
  createAuthorizationManagementStore,
} from "@haskoning/vue-authorization-middleware";
import DeleteDialog from "@/components/dialog/DeleteDialog.vue";
import * as Sentry from "@sentry/vue";
import HeaderImage from '@/assets/header.jpg'
import HeaderImageLazy from '@/assets/header_lazy.jpg'

const { api, client } = useFeathers();
const snackbarStore = useSnackbarStore(pinia);
const authStore = useAuthStore(pinia)

const useAuthorizationManagementRolesStore = createAuthorizationManagementStore(
  api,
  snackbarStore
);
const authorizationManagementRolesStore =
  useAuthorizationManagementRolesStore(pinia);

const app = createApp(App);
app
  .use(vuetify)
  .use(pinia)
  .use(router)
  .use(AuthenticationManagement, {
    appTitle: "CDM",
    api: api,
    headerImage: HeaderImage,
    headerImageLazy: HeaderImageLazy,
    snackbarStore: useSnackbarStore(pinia),
    authStore,
    showUsernameAndPasswordLogin: false,
    apiBaseUrl: import.meta.env.VITE_APP_API_BASE_URL,
    apiBackend: 'feathers'
  })
  .use(AuthorizationManagement, {
    DeleteDialog,
    authorizationManagementRolesStore,
    feathers: api,
    restClient: client,
    authStore: useAuthStore(pinia),
    apiBaseUrl: import.meta.env.VITE_APP_API_BASE_URL,
  })
  // This must be improved probably
  .provide(
    "authorizationManagementRolesStore",
    authorizationManagementRolesStore
  )

Sentry.init({
    app,
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
        Sentry.feedbackIntegration({
            triggerLabel: 'Feedback',
            formTitle: 'Send Feedback',
            submitButtonLabel: 'Send Feedback',
            cancelButtonLabel: 'Cancel',
            messagePlaceholder: 'What would you like to tell us?',
            successMessageText: 'Thank you for your feedback!',
            colorScheme: 'light',
            showName: true,
            showEmail: true,
            enableScreenshot: true,
            autoInject: false
        })
    ],
    tracePropagationTargets: ["*"],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

router.isReady().then(() => {
    app.mount('#app')

    const feedback = Sentry.getFeedback()
    if (!feedback) return

    let widget = null

    const isAuthenticated = () => {
        return !!authStore.$state.user
    }

    const updateFeedbackWidget = () => {
        if (isAuthenticated() && !widget) {
            widget = feedback.createWidget()
            widget.appendToDom()
            if (authStore.$state.user?.email) {
                Sentry.setUser({
                    username: authStore.$state.user?.firstName ?? '',
                    email: authStore.$state.user?.email ?? ''
                })
            }
        } else if(isAuthenticated() && widget) {
            Sentry.setUser({
                username: authStore.$state.user?.firstName ?? '',
                email: authStore.$state.user?.email ?? ''
            })
        } else if (!isAuthenticated() && widget) {
            widget.removeFromDom()
            widget = null
            Sentry.setUser(null)
        }
    }
    updateFeedbackWidget()
    authStore.$subscribe(updateFeedbackWidget)
})

export default app;
